import { render, staticRenderFns } from "./SoundsList.vue?vue&type=template&id=05d8d69c&"
import script from "./SoundsList.vue?vue&type=script&lang=js&"
export * from "./SoundsList.vue?vue&type=script&lang=js&"
import style0 from "./SoundsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports